import { LIST_EVENT_TRIGGER_TYPES } from 'automation-ui-enrollment/utils/listFilters';
export const isEventBasedWorkflow = flow => {
  return flow.enrollmentTrigger === 'EVENT';
};
export const hasEventEnrollmentTriggers = flow => {
  var _flow$enrollmentCrite;
  const hasFlowEventFilters = flow.flowEventFilters.some(filter => filter.flowEventFilterType === 'ANY_ENROLLMENT' || filter.flowEventFilterType === 'FIRST_TIME_ENROLLMENT');
  const hasListEventTriggers = flow.associatedLists.some(list => list.listTypes.some(listType => LIST_EVENT_TRIGGER_TYPES.includes(listType)));
  return hasFlowEventFilters || hasListEventTriggers || ((_flow$enrollmentCrite = flow.enrollmentCriteria) === null || _flow$enrollmentCrite === void 0 ? void 0 : _flow$enrollmentCrite.triggerType) === 'EVENT';
};
export const getExistingTriggerType = flow => {
  if (isEventBasedWorkflow(flow) && hasEventEnrollmentTriggers(flow)) {
    return 'EVENT';
  } else if (flow.enrollmentSchedule) {
    return 'SCHEDULE';
  } else if (flow.associatedLists.find(list => list.listTypes.includes('ENROLLMENT_LIST'))) {
    return 'LIST';
  }
  return undefined;
};